import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { approveControllerVisits } from "../../api/server";
import { withNotifications } from "../notifications/notificationsSlice";

export const approveHouseVisits = createAsyncThunk(
  "controllersHouseVisits/approve",
  withNotifications(
    async (params, thunkAPI) => {
      const { data } = params;
      const ids = data.map((item) => item.id);
      const scopePrefix = thunkAPI.getState().auth.scopePrefix;
      const employeeId = thunkAPI.getState().employee.activeEmployee.id;
      return approveControllerVisits({ ids, scopePrefix, employeeId });
    },
    "approve_house_visit",
    "approve_house_visit_success",
    "approve_house_visit_error"
  )
);

const initialPageSize = 100;
const initialState = {
  page: {
    current: 1,
    pageSize: initialPageSize,
    filter: {
      freeText: null,
    },
    order: {
      field: "date",
      order: "ascend",
    },
  },
};

const controllerVisitsSlice = createSlice({
  name: "controllerVisits",
  initialState: initialState,
  reducers: {
    setPage(state, { payload: page }) {
      state.page = page;
    },
    reset(state, action) {
      state.page = initialState.page;
    },
  },
  extraReducers: {
    [approveHouseVisits.fulfilled]: (state, action) => {
      state.page = initialState;
    },
    [approveHouseVisits.rejected]: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setPage, reset } = controllerVisitsSlice.actions;

export default controllerVisitsSlice.reducer;

// export const approveAll = () => (dispatch, getState) => {
//   const ids = getState().controllerVisits.page.items.map((item) => item.id);
//
//   const scopePrefix = getState().auth.scopePrefix;
//   const employeeId = getState().employee.activeEmployee.id;
//   dispatch(approveHouseVisits({ ids, scopePrefix, employeeId }));
// };
